export default __webpack_public_path__ + "static/favicon-bb1bd8183d42e9c40169c9f691825637.ico";